'use client';

import { AnimatePresence, motion } from '@/libs';

type PulsingCirclesProps = {
  visible: boolean;
};

export const PulsingCircles = ({ visible }: PulsingCirclesProps) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="absolute inset-0 flex items-center justify-center pointer-events-none z-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="relative w-64 h-64 md:w-72 md:h-72 flex items-center justify-center">
            <motion.div
              className="absolute rounded-full animate-circlePulse1"
              style={{
                width: '60px',
                height: '60px',
                background:
                  'radial-gradient(circle, rgba(255,215,0,0.5) 0%, rgba(255,193,7,0.3) 50%, transparent 100%)',
                filter: 'blur(8px)',
              }}
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.1 }}
            />
            <motion.div
              className="absolute rounded-full animate-circlePulse2"
              style={{
                width: '60px',
                height: '60px',
                background:
                  'radial-gradient(circle, rgba(255,215,0,0.4) 0%, rgba(255,165,0,0.2) 50%, transparent 100%)',
                filter: 'blur(6px)',
              }}
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            />
            <motion.div
              className="absolute rounded-full animate-circlePulse3"
              style={{
                width: '60px',
                height: '60px',
                background:
                  'radial-gradient(circle, rgba(255,255,255,0.4) 0%, rgba(255,215,0,0.2) 50%, transparent 100%)',
                filter: 'blur(4px)',
              }}
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
